module.exports = __webpack_public_path__ + "static/img/01.3b4c13b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/artical/health/01.png
// module id = uzok
// module chunks = 1